import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { Box, Button, Typography } from '@mui/material';

const ApplicationUnassignedPage: React.FC = () => {
    const { t } = useTranslation();
    const { logout } = useAuth();
  
    const handleSignOut = async () => {
        try {
        await logout();
        } catch (error) {
        console.error('Error signing out:', error);
        }
    };


    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="100vh"
            padding={3}
            sx={{ backgroundColor: '#f5f5f5' }}
        >
            <Box
            sx={{
                backgroundColor: 'white',
                padding: 4,
                borderRadius: 2,
                boxShadow: 2,
                textAlign: 'center',
                maxWidth: 500
            }}
            >
            <Typography variant="h5" color="error" gutterBottom>
                {t('applicationUnassigned.title')}
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                {t('applicationUnassigned.notAssignedMessage')}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
                {t('applicationUnassigned.contactSupportMessage')}
            </Typography>
            </Box>
        </Box>
    );
};

export default ApplicationUnassignedPage;